import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, FileText, Calculator, MessageCircle, ClipboardList, HeartHandshake } from 'lucide-react';
export function TomosGrid() {
  const tomos = [{
    num: '01',
    icon: <Smartphone className="w-6 h-6 text-brand-pink" data-id="element-147" />,
    title: 'Marketing y Redes',
    desc: 'Calendario 365 días y estrategias para Reels que atraen clientas reales.'
  }, {
    num: '02',
    icon: <FileText className="w-6 h-6 text-brand-pink" data-id="element-148" />,
    title: 'Gestión y Legal',
    desc: 'Fichas clínicas profesionales y sistema anti-plantones para proteger tu tiempo.'
  }, {
    num: '03',
    icon: <Calculator className="w-6 h-6 text-brand-pink" data-id="element-149" />,
    title: 'Finanzas e Inflación',
    desc: 'Calculadora de costos reales y estrategia para suba de precios sin perder clientas.'
  }, {
    num: '04',
    icon: <MessageCircle className="w-6 h-6 text-brand-pink" data-id="element-150" />,
    title: 'Ventas y WhatsApp',
    desc: 'Scripts de cierre comprobados para que dejen de clavarte el visto.'
  }, {
    num: '05',
    icon: <ClipboardList className="w-6 h-6 text-brand-pink" data-id="element-151" />,
    title: 'Operatividad',
    desc: 'Protocolos de gabinete paso a paso y gestión de stock inteligente.'
  }, {
    num: '06',
    icon: <HeartHandshake className="w-6 h-6 text-brand-pink" data-id="element-152" />,
    title: 'Fidelización',
    desc: 'Cómo crear una experiencia única para que una clienta te compre de por vida.'
  }];
  return <section className="py-24 bg-brand-black" data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-156">
            Lo que vas a recibir
          </h2>
          <p className="text-brand-pink font-medium tracking-widest uppercase text-sm" data-id="element-157">
            LOS 6 TOMOS DEL SISTEMA
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-158">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group relative bg-[#0a0a0a] p-8 rounded-2xl border border-white/10 hover:border-brand-pink/50 transition-all duration-300 overflow-hidden" data-id="element-159">
              <div className="absolute -right-4 -top-4 text-[120px] font-serif font-bold text-white/[0.02] group-hover:text-brand-pink/[0.05] transition-colors duration-300 pointer-events-none leading-none" data-id="element-160">
                {tomo.num}
              </div>

              <div className="relative z-10" data-id="element-161">
                <div className="flex items-center gap-4 mb-6" data-id="element-162">
                  <div className="w-12 h-12 rounded-full bg-brand-pink/10 flex items-center justify-center border border-brand-pink/20" data-id="element-163">
                    {tomo.icon}
                  </div>
                  <span className="text-brand-pink font-serif font-bold text-xl" data-id="element-164">
                    Tomo {tomo.num}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-white mb-3" data-id="element-165">
                  {tomo.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-166">{tomo.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}